<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="原始密码" prop="orpassword">
        <el-input show-password v-model.trim="form.orpassword" clearable :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input show-password v-model.trim="form.password" clearable :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="repassword">
        <el-input show-password v-model.trim="form.repassword" clearable :maxlength="32"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,checkPwd} from '@utils/validate'
  export default {
    name: "ResetPassword",
    props: {dialogData: Object},
    data() {
      let checkRePass = (rule, value, callback) => {
        if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        form: {
          orpassword: "",
          password: "",
          repassword: "",
        },
        rules: {
          orpassword: [inputEmpty("原始密码"), checkPwd()],
          password: [inputEmpty("新密码"), checkPwd()],
          repassword: [inputEmpty('确认密码'), {validator: checkRePass, trigger: 'blur'}],
        },
      }
    },
    methods: {
      confirm() {
        this.$refs["form"].validate(isOk => {
          if (isOk) {
            this.openConfirm("重置管理员密码", async () => {
              let nv = {...this.form};
              let res = await this.$Http.resetPassword(nv);
              if (res) {
                this.openAlert("重置成功", () => {
                  this.$router.push("/login");
                })
              }
            });
          }
        });
      },
    },
  }
</script>

<style scoped>

</style>
